/**
 * A deferred promise to allow settle later.
 */
export class DeferredPromise extends Promise {
    #resolve;
    #reject;

    /**
     * @param {?Function} [executor] - Eager executor.
     */
    constructor(executor = null) {
        let innerResolve, innerReject;

        super((resolve, reject) => {
            innerResolve = resolve;
            innerReject  = reject;
        });

        this.#resolve = innerResolve;
        this.#reject  = innerReject;

        if (executor) {
            executor(this.#resolve, this.#reject);
        }
    }

    /**
     * @param {Function} executor - Lazy executor.
     */
    execute(executor) {
        executor(this.#resolve, this.#reject);
        return this;
    }

    resolve(value) {
        this.#resolve(value);
        return this;
    }

    reject(reason) {
        this.#reject(reason);
        return this;
    }
}
